import { Component, OnInit, AfterViewInit } from '@angular/core';
import { BreadcrumbService, DashboardService, ApplicationService, HttpWrapperService, ProfileService, OcrService } from '@picard/services-lib';
import { MenuItem } from 'primeng/primeng';
import { StorageConstants, isNil } from '@picard/shared-lib';
import { LogonResponse, DynamicPanelModel, WidgetModel, WidgetItem, PreAuthenticationResponse, FileUploadModel, FileUploadResponse, OcrStatus, GetConversionVoucherDetailsResponse, ConversionVoucherInfo, ConvertLoyaltyToVoucherRequest, ConvertLoyaltyToVoucherRequestVoucher, ConvertLoyaltyToVoucherResponse, UserLoyaltyVoucherInstance } from '@picard/models-lib';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Title } from '@angular/platform-browser';
import { Http } from '@angular/http';

import Swal from 'sweetalert2';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VerificationValueResponse } from './VerificationValueResponse';
import { Options } from '@angular-slider/ngx-slider';
import { FormControl, FormGroup } from '@angular/forms';
import { HostComponent } from 'src/app/layout/host/host.component';
import { isNullOrUndefined } from 'util';

// Todo: rewrite how it loads the dashboard to load all for a specific programme
@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
})
export class DashboardComponent implements OnInit, AfterViewInit {
  //#region Properties
  privateData: string;
  preAuthenticationResponse: PreAuthenticationResponse;
  preAuthBeansResponse: any;
  user: string;
  dynamicPanelModel: DynamicPanelModel;
  widgetModel: WidgetModel;
  widgetBeansModel: WidgetModel;
  widgetBeansModelResponse: WidgetModel;
  hasRenderedConfigDetails: boolean;
  loadedDynamicPanel: boolean;
  @BlockUI() blockUI: NgBlockUI;
  documentation: any;
  logonResponse: LogonResponse;
  docTheme = document.getElementById("theme-css");
  docLayout = document.getElementById("layout-css");
  programId: number;
  programIdBeans: number;
  getVerificationValueResponse: VerificationValueResponse;
  veriModel: VerificationValueResponse;
  newRedemptionPin: number;
  receiptUrl: string = "";
  imgUploaded: boolean = false;
  mobileIsIntCustom: boolean = false;

  fileDetails: FileUploadModel;
  fileUploadResponse: FileUploadResponse;

  getConversionVoucherDetailsResponse: GetConversionVoucherDetailsResponse;
  availableVoucherDetails: ConversionVoucherInfo[];
  availableVoucherDetails2: ConversionVoucherInfo[];
  convertLoyaltyToVoucherResponse: ConvertLoyaltyToVoucherResponse;
  rewardConverted: boolean = false;
  voucherInstances: UserLoyaltyVoucherInstance[] = [];

  value: number = 50;
  value2: number = 0;
  value3: number = 0;
  options: Options = {
    floor: 50,
    ceil: 1000,
    step: 50,
    hideLimitLabels: true,
    showTicksValues: true,
    translate: (value: number): string => {
      return "R" + value;
    },
  };

  sub: number = 0;
  sliderDisabled: boolean = false;
  isMobile = false;
  openVoucherModal: number = 0;
  rewardValue: string = '0';
  MobileQRUrl: string;
  progShortcode: string;
  //#endregion Properties

  // Todo: remove the httpWrapper from here as this is massive pattern break. doing this to accommodate tight timelines
  //#region Constructor
  constructor(
    private _breadcrumbService: BreadcrumbService,
    public hostComponent: HostComponent,
    private _dashboardService: DashboardService,
    private _router: Router,
    private _applicationService: ApplicationService,
    private _profileService: ProfileService,
    private _ocrService: OcrService,
    private _title: Title,
    private _httpWrapperService: HttpWrapperService,
    private _http: Http,
    private route: ActivatedRoute
  ) {
    this._breadcrumbService.setItems([
      { label: "Dashboard", routerLink: "/dashboard" },
    ]);
    this.programId = parseInt(sessionStorage.getItem("programID"));
    const preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);
    if (preAuthJson) {
      var preAuthResp : PreAuthenticationResponse = JSON.parse(preAuthJson);
      this.progShortcode = preAuthResp.code;
    }
    
    setInterval(() => {
      this.isMobile = hostComponent.isMobile();
    }, 2000);
  }
  //#endregion Constructor

  //#region Functions
  async ngOnInit() {
    this.programId = parseInt(sessionStorage.getItem("programID")); // this._applicationService.preAuthenticationResponse.programId;

    if (!this.progShortcode.includes('pvtk') && this.programId === 2222) {
      this.preAuthBeansResponse = JSON.parse(
        sessionStorage.getItem("preAuthBeans")
      );
      this.programIdBeans = this.preAuthBeansResponse.programId;
    }

    this.privateData = sessionStorage.getItem("private-key");
    const htmlBody: HTMLLinkElement = <HTMLLinkElement>(
      document.getElementById("top-menu")
    );

    // Els Problem child
    // htmlBody.className = 'topbar-menu fadeInDown';
    try {
      const preAuthJson = sessionStorage.getItem(StorageConstants.preAuth);
      if (preAuthJson) {
        this.preAuthenticationResponse = JSON.parse(preAuthJson);
        this._title.setTitle(
          `${this.preAuthenticationResponse.description} - Dashboard`
        );
        if (this.docTheme) {
          this.docTheme.setAttribute(
            "href",
            this.preAuthenticationResponse.programmeAssetsModel.theme
          );
        }
        if (this.docLayout) {
          this.docLayout.setAttribute(
            "href",
            this.preAuthenticationResponse.programmeAssetsModel.layout
          );
        }
      } else {
        this._title.setTitle("Electronicline");
      }

      if (
        this.preAuthenticationResponse.showLinkedProgrammes != null &&
        !this.preAuthenticationResponse.showLinkedProgrammes
      ) {
        this.logonResponse = JSON.parse(
          sessionStorage.getItem(StorageConstants.loginDetails)
        );
        var first6 = this.logonResponse.usersModel.mobileNumber.slice(0, 6);
        if (first6 === "011100") {
          this.mobileIsIntCustom = true;
        }
        this.getVerificationValueResponse =
          await this._profileService.GetUserVerficationValueAsync();

        this.generateQR(this.logonResponse.usersModel.mobileNumber);  
        this.blockUI.start("Loading dashboard panel.");
        const dynamicPanelModelInitialResponse: DynamicPanelModel =
          (this.dynamicPanelModel =
            await this._dashboardService.GetDynamicPanelForDashboardAsync());
        this.blockUI.stop();
        this.blockUI.start("Rendering dashboard panel.");
        this.dynamicPanelModel =
          await this._dashboardService.RenderDynamicPanelModelAsync(
            dynamicPanelModelInitialResponse
          );
        this.blockUI.stop();
        this.loadedDynamicPanel = true;
        this.hasRenderedConfigDetails = true;
      } else {
        this.hasRenderedConfigDetails = true;
      }
    } catch (error) {
      this.loadedDynamicPanel = false;
      this.hasRenderedConfigDetails = false;
      this.blockUI.stop();
      console.log(error);
    }

    if (!this.progShortcode.includes('pvtk') && (this.programId === 2555 || this.programId === 2550)) {
      try {
        this.blockUI.start("Loading voucher amounts.");
        this.getConversionVoucherDetailsResponse =
          await this._dashboardService.GetConversionVoucherDetailsAsync();
        this.availableVoucherDetails =
          this.getConversionVoucherDetailsResponse.availableVoucherDetails;
        this.availableVoucherDetails.sort((a, b) => a.value - b.value);
        this.blockUI.stop();
      } catch (error) {
        this.blockUI.stop();
        console.log(error);
      }
    }
  }
  async ngAfterViewInit() {
    if (!this.preAuthenticationResponse.showLinkedProgrammes) {
      const logonResponse: LogonResponse = JSON.parse(
        sessionStorage.getItem(StorageConstants.loginDetails)
      );
      const logonBeansResponse: LogonResponse = JSON.parse(
        sessionStorage.getItem("loginBeansDetails")
      );

      this.getVerificationValueResponse =
        await this._profileService.GetUserVerficationValueAsync();

      this.blockUI.start("Loading dashboard widgets.");
      const widgetModelResponse: WidgetModel = (this.widgetModel =
        await this._dashboardService.GetWidgetModelAsync());
      if (!this.progShortcode.includes('pvtk') && this.programId === 2222 && logonBeansResponse.usersModel != null) {
        this.widgetBeansModelResponse = this.widgetBeansModel =
          await this._dashboardService.GetSecondaryWidgetModelAsync();
      }
      this.blockUI.stop();
      this.blockUI.start("Rendering dashboard widgets.");
      this.widgetModel = await this._dashboardService.RenderWidgetModelAsync(
        widgetModelResponse
      );
      if (!this.progShortcode.includes('pvtk') && this.programId === 2222 && logonBeansResponse.usersModel != null) {
        this.widgetBeansModel =
          await this._dashboardService.RenderSecondaryWidgetModelAsync(
            this.widgetBeansModelResponse
          );
      }

      if (!this.progShortcode.includes('pvtk') && (this.programId === 2555 || this.programId === 2550)){
        this.widgetModel.widgetItemCollection.forEach(obj => {
          if(obj.title === 'REWARDS POINTS BALANCE'){
            sessionStorage.setItem("LoyaltyRewardBalance", obj.description);
            this.rewardValue = obj.description;
          }
        });
        console.log("WIDGET", this.widgetModel);
      }

      this.route.params.subscribe(params => {
        this.openVoucherModal = params['open'];
      });
      if (this.openVoucherModal == 1){
        this.openConvertModal();
      }
      this.blockUI.stop();
      this.hasRenderedConfigDetails = true;
    } else {
      this.documentation = await this._httpWrapperService
        .get("assets/config/mock/documentation-dashboard.moq.json", true)
        .toPromise()
        .then((x) => x.json());
      if (this.documentation) {
        this.documentation.endpoints.forEach(async (endpoint) => {
          const template = await this._http
            .get(endpoint.route)
            .toPromise()
            .then((x) => x);
          endpoint.template = template.text();
          // .pipe(map((html: any) => (endpoint.template = html)));
        });
      }
      console.log(this.documentation);
      this.hasRenderedConfigDetails = true;
    }
    this.imgUploaded = false;
  }
  onRouteAction(route: string) {
    this._router.navigateByUrl(route);
  }
  setWidgetStyles(item: string) {
    const styles = {
      "background-color": item,
    };
    return styles;
  }

  openModal() {
    const modal = document.getElementById("myModal");
    modal.style.display = "block";
  }

  closeModal() {
    const modal = document.getElementById("myModal");
    modal.style.display = "none";
  }
  MoreDenominations() {
    this.sliderDisabled = !this.sliderDisabled;
    this.options = Object.assign({}, this.options, {
      disabled: this.sliderDisabled,
    });

    const denomBtnElement = document.getElementById("denomBtn");
    if (this.sliderDisabled == true) {
      denomBtnElement.style.backgroundColor = "#8cafb2";
      this.value = this.availableVoucherDetails[0].value;
    } else {
      denomBtnElement.style.backgroundColor = "#231f20";
      this.value2 = 0;
    }
  }
  openConvertModal() {
    /*const newOptions: Options = Object.assign({}, this.options);
    this.sub = this.availableVoucherDetails.length;
    this.sub = this.sub / 2;

    this.availableVoucherDetails2 = this.availableVoucherDetails.slice(
      this.sub
    );

    var newCeil = this.availableVoucherDetails[this.sub - 1].value;
    newOptions.ceil = newCeil;
    this.options = newOptions;*/

    const modal = document.getElementById("conversionModal");
    modal.style.display = "block";

    this.sliderDisabled = false;
  }

  closeConvertModal() {
    const modal = document.getElementById("conversionModal");
    modal.style.display = "none";
    this.rewardConverted = false;
  }

  openVoucherDetials(voucherInstanceId: number) {
    this._router.navigateByUrl(`/vouchers/${voucherInstanceId}`);
  }

  async ConvertReward() {
    try {
      this.blockUI.start("Generating voucher...");
      var convertLoyaltyToVoucherRequest = new ConvertLoyaltyToVoucherRequest();
      var selectedVoucher = new ConvertLoyaltyToVoucherRequestVoucher();

      // var selectedValue = this.sliderDisabled ? this.value2 : this.value;
      // if (this.isMobile) selectedValue = this.value3;
      var selectedValue = this.percentageForm.value.percentage ? this.percentageForm.value.percentage : 0;
      if (selectedValue === '0') throw new Error("Please select a voucher amount");

      console.log("Selected value: ", selectedValue);
      selectedVoucher.voucherId = this.availableVoucherDetails.find(
        (x) => x.value == selectedValue
      ).voucherId;
      selectedVoucher.quantity = 1;

      convertLoyaltyToVoucherRequest.vouchers = [];
      convertLoyaltyToVoucherRequest.vouchers.push(selectedVoucher);
       var response = await this._dashboardService
         .ConvertLoyaltyToVoucherAsync(convertLoyaltyToVoucherRequest)
         .then((x) => JSON.stringify(x));
       this.convertLoyaltyToVoucherResponse = JSON.parse(response);

      //this.convertLoyaltyToVoucherResponse = JSON.parse('{"userId":"2538646","availableVoucherDetails":[{"voucherInstanceId":44499399,"voucherId":6412,"code":"2853282","status":2,"shortDescription":"R50 Time & Co. Gift Card","productDescription":"R50 to spend at Time & Co. Gift Card","balance":100.00,"voucherImage":"https://yapnew.blob.core.windows.net/logos/partner_1735/voucher_6412/Time&Co_Rewards_Voucher.png"}],"isSuccessful":"true","message":"Success","responseType":0}')
      this.blockUI.stop();
      if (this.convertLoyaltyToVoucherResponse.isSuccessful) {
        Swal({
          title: "Reward conversion was successful",
          text: this.convertLoyaltyToVoucherResponse.message,
        });
        this.rewardConverted = true;
        this.voucherInstances =
          this.convertLoyaltyToVoucherResponse.availableVoucherDetails;

          this.blockUI.start("Refresh dashboard widgets.");
          this.widgetModel = await this._dashboardService.RenderWidgetModelAsync(
            this.widgetModel
          );
          if (this.programId === 2555 || this.programId === 2550){
            this.widgetModel.widgetItemCollection.forEach(obj => {
              if(obj.title === 'REWARDS POINTS BALANCE'){
                sessionStorage.setItem("LoyaltyRewardBalance", obj.description);
                this.rewardValue = obj.description;
              }
            });
            console.log("WIDGET", this.widgetModel);
          }
          this.blockUI.stop();  
      } else {
        Swal(
          "Reward conversion failed",
          "" + JSON.stringify(this.convertLoyaltyToVoucherResponse.message),
          "error"
        );
      }
    } catch (error) {
      this.rewardConverted = false;
      this.blockUI.stop();
      console.log(error);
      Swal("Reward conversion failed", "" + error, "error");
    }
  }

  async onUpdate(
    isActive: boolean,
    value: number,
    enableAltLoyaltyCode: boolean
  ) {
    this.blockUI.start("Updating.");
    const updateVerificationValueResponse: VerificationValueResponse =
      await this._profileService.UpdateVerficationValueAsync(
        isActive,
        value,
        enableAltLoyaltyCode
      );
    if (updateVerificationValueResponse.responseType === 0) {
      this.getVerificationValueResponse =
        await this._profileService.GetUserVerficationValueAsync();
    }
    this.blockUI.stop();
    this.closeModal();
  }

  async onSelect(event) {
    this.imgUploaded = false;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      let fileType = event.target.files[0].type;
      if (fileType.match(/image\/*/)) {
        let reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event: any) => {
          this.receiptUrl = event.target.result;
          this.imgUploaded = true;
        };

        this.fileDetails = {
          fileDetails: file,
          mobileNumber: this.logonResponse.usersModel.mobileNumber,
          programId: this.programId,
        };

        this.blockUI.start("Uploading receipt");
        var respon = await this._ocrService
          .ProcessLoyaltyAsync(this.fileDetails)
          .then((x) => JSON.stringify(x));
        this.fileUploadResponse = JSON.parse(respon);
        this.blockUI.stop();
        if (this.fileUploadResponse.code === OcrStatus.Success) {
          Swal({
            title: "Receipt upload was successful",
            text: this.fileUploadResponse.message,
          });
        } else {
          Swal(
            "Receipt upload failed: ",
            JSON.stringify(this.fileUploadResponse.message),
            "error"
          );
        }
      } else {
        Swal(
          "Image selection failed: ",
          "Please select correct image format",
          "error"
        );
      }
    }
  }
  toVouchers() {
    this._router.navigateByUrl(`/voucher-landing`);
  }
  //#endregion Functions

  bathOneDenominations = [
    {
      value: 50,
    },
    {
      value: 100,
    },
    {
      value: 150,
    },
    {
      value: 200,
    },
    {
      value: 250,
    },
    {
      value: 300,
    },
    {
      value: 350,
    },
    {
      value: 400,
    },
    {
      value: 450,
    },
    {
      value: 500,
    },
  ];

  batchTwoDenominations = [
    {
      value: 550,
    },
    {
      value: 600,
    },
    {
      value: 650,
    },
    {
      value: 700,
    },
    {
      value: 750,
    },
    {
      value: 800,
    },
    {
      value: 850,
    },
    {
      value: 900,
    },
    {
      value: 950,
    },
    {
      value: 1000,
    },
  ];
  testVouchers = this.bathOneDenominations

  batch = 'batchOne'
  shoInfo = false;

  toggleInfo() {
    this.shoInfo = !this.shoInfo;
  }

  percentageForm = new FormGroup({
    percentage: new FormControl("50"),
  });

  onPercentageChange() {
    console.log("PERCENT CHNAGE ", this.percentageForm.value);
  }

  onBatchChange() {

    this.batch = this.batch === "batchOne" ? "batchTwo" : "batchOne";
    if (this.batch === 'batchOne') {
      this.testVouchers = this.bathOneDenominations
      this.percentageForm.patchValue({ percentage: "50" });
    } else {
      this.testVouchers = this.batchTwoDenominations
      this.percentageForm.patchValue({ percentage: "550" });
    }
    
  }

  generateQR(mobile: string){
    this.MobileQRUrl = "http://api.qrserver.com/v1/create-qr-code/?ecc=1L&margin=5&size=100x100&data="+mobile;
  }
}
